import axios from 'axios';
import { axiosInstance } from '../Axios';
import { SearchEtravDispatch, searchEtravSuccess } from './EtravReducer';
import { SearchTBOFlightDispatch, TBOFlightSuccess } from './TBOReducer';
import { SearchTripjackDispatch } from './TripjackReducer';
import { setSelectedArrival, setSelectedDepart } from './UiReducer';
const { createSlice } = require('@reduxjs/toolkit');

const HomeReducer = createSlice({
	name: 'home',
	initialState: {
		success: false,
		error: null,
		loadinghome: false,
		city: null,
		orderID: null,
		hotel: null,
		bannerresult: null,
		populardesc: null,
	},
	reducers: {
		cityRequest(state, action) {
			state.loadinghome = true;
		},

		citySuccess(state, action) {
			state.loadinghome = false;
			state.city = action.payload;
			state.error = null;
		},
		cityFail(state, action) {
			state.loadinghome = false;
			state.error = action.payload;
		},
		addSearchRequest(state, action) {
			state.loadinghome = true;
		},

		orderIDGenerate(state, action) {
			state.loadinghome = false;
			state.orderID = action.payload;
			state.error = null;
		},
		addSearchFail(state, action) {
			state.loadinghome = false;
			state.error = action.payload;
		},
		hotelRequest(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		hotelSuccess(state, action) {
			state.loading = false;
			state.hotel = action.payload;
			state.error = null;
		},
		hotelFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		bannerRequest(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		bannerSuccess(state, action) {
			state.loading = false;
			state.bannerresult = action.payload;
			state.error = null;
		},
		bannerFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		PopularDescRequest(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		PopularDescSuccess(state, action) {
			state.loading = false;
			state.populardesc = action.payload;
			state.error = null;
		},
		PopularDescFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = HomeReducer;
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};
export const {
	cityRequest,
	citySuccess,
	cityFail,
	addSearchRequest,
	orderIDGenerate,
	addSearchFail,
	hotelRequest,
	hotelSuccess,
	hotelFail,
	bannerRequest,
	bannerSuccess,
	bannerFail,
	PopularDescRequest,
	PopularDescSuccess,
	PopularDescFail,
} = actions;

export const fetchCityDispatch = (bodyData) => async (dispatch) => {
	try {
		const configs = {
			headers: {
				'Content-Type': 'application/json',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
			},
		};
		const { data } = await axiosInstance.post(
			'home/flightairport',
			bodyData,
			configs
		);
		dispatch(citySuccess(data));
		if (bodyData.limits === 8) {
			dispatch(setSelectedDepart(data?.result[1]));
			dispatch(setSelectedArrival(data?.result[7]));
		}
	} catch (error) {
		dispatch(
			cityFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const AddSearchFlightDispatch =
	(bodyData, navigate) => async (dispatch) => {
		try {
			dispatch(searchEtravSuccess(null));
			dispatch(TBOFlightSuccess(null));
			dispatch(addSearchRequest());

			const { data } = await axiosInstance.post(
				'flight/addsearchflight',
				bodyData,
				config
			);
			dispatch(orderIDGenerate(data));
			if (data.status === 200) {
				dispatch(SearchTBOFlightDispatch(bodyData));
				// dispatch(SearchEtravDispatch(bodyData));
				// dispatch(SearchTripjackDispatch(bodyData));
			} else {
			}
		} catch (error) {
			dispatch(
				addSearchFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const fetchHotel = (bodyData) => async (dispatch) => {
	try {
		dispatch(hotelRequest());

		const { data } = await axiosInstance.post('home/hotel', bodyData, config);
		console.log(data);
		dispatch(hotelSuccess(data));
	} catch (error) {
		dispatch(
			hotelFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const fetchBanner = () => async (dispatch) => {
	try {
		dispatch(bannerRequest());

		const { data } = await axios.get(
			'http://3.109.56.190/api/partner/banner',
			config
		);
		console.log(data);
		dispatch(bannerSuccess(data));
	} catch (error) {
		dispatch(
			bannerFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const fetchPopularDesc = () => async (dispatch) => {
	try {
		dispatch(PopularDescRequest());

		const { data } = await axios.get(
			'http://3.109.56.190/api/partner/populardes',
			config
		);
		console.log(data);
		dispatch(PopularDescSuccess(data));
	} catch (error) {
		dispatch(
			PopularDescFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export default HomeReducer;
